import { HeaderLogo } from "components/header/styled";
import { Box, Typography, useTheme } from "@mui/material";
import { Brick } from "components/Brick";
import { OnboardingCardV2 } from "components/OnBoarding/styled";

import { FullViewContainer } from "components/OnBoarding/styled";
import useStepper from "v2/components/base/Stepper/hooks/useStepper";
import Stepper from "v2/components/base/Stepper/ui";
import { OnBoardingConfigs } from "../../utils/configs";
import CabalTownLogo from "assets/icons/cabal-town-logo-v2.png";
import { RetroButton } from "components/RetroButton";
import { Col, Row } from "v2/components/base/Flex/ui";
import BasicButton from "v2/components/Buttons/BasicButton";
import { ViewPoint } from "v2/components/base/ResponsiveLayout/ui";

export const OnboardingWrapper = ({
  slide,
  handleNextSlide,
  onBoardingConfig,
  handleOnboard,
  handleSlideChange,
  children,
  ...props
}: {
  slide: number;
  handleNextSlide: () => void;
  handleOnboard: () => void;
  handleSlideChange: (slide: number) => void;
  onBoardingConfig: OnBoardingConfigs;
  children: React.ReactNode;
}) => {
  const theme = useTheme();

  return (
    <FullViewContainer sx={{ backgroundColor: theme.palette.surface.black }}>
      <ViewPoint.Mobile>
        <OnboardingCardV2
          sx={{
            display: "flex",
            position: "relative",
            backgroundImage: `
              linear-gradient(
                to left,
                ${theme.palette.surface.black}00 0%,
                ${theme.palette.surface.black}00 80%,
                ${theme.palette.surface.black}FF 95%,
                ${theme.palette.surface.black}FF 100%
              ),
              linear-gradient(
                to right,
                ${theme.palette.surface.black}00 0%,
                ${theme.palette.surface.black}00 80%,
                ${theme.palette.surface.black}FF 95%,
                ${theme.palette.surface.black}FF 100%
              ),
              linear-gradient(
                to bottom,
                ${theme.palette.surface.black}00 0%,
                ${theme.palette.surface.black}00 50%,
                ${theme.palette.surface.black}FF 90%,
                ${theme.palette.surface.black}FF 100%
              ),
              linear-gradient(
                to top,
                ${theme.palette.surface.black}00 0%,
                ${theme.palette.surface.black}00 80%,
                ${theme.palette.surface.black}FF 95%,
                ${theme.palette.surface.black}FF 100%
              ),
              url("${onBoardingConfig[slide].image}")
            `,
            backgroundPosition: "0 70%",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            margin: "0 auto",
            width: "100%",
            maxWidth: "1200px",
          }}>
          <Col type="bc" fullWidth sx={{ paddingY: "16px" }} fullHeight>
            <Row
              type="cc"
              sx={{
                width: "100%",
                gap: "16px",
                padding: "12px 0 16px",
              }}
              fullWidth>
              <Stepper
                sx={{
                  maxWidth: "600px",
                }}
                slide={slide}
                totalSlides={onBoardingConfig.length}
                handleSlideChange={handleSlideChange}
              />
            </Row>
            <Col
              type="bc"
              sx={{
                gap: "16px",
              }}
              fullWidth
              fullHeight>
              <Col
                type="ec"
                sx={{
                  overflowX: "scroll",
                  scrollSnapType: "x mandatory",
                  msScrollSnapPointsX: "repeat(100vw)",
                  gap: "12px",
                }}
                fullWidth
                fullHeight>
                <Row type="bc" fullWidth>
                  {children}
                </Row>
              </Col>
              <Col type="cc" fullWidth>
                <Row
                  type="bc"
                  sx={{
                    padding: "0",
                    gap: "10px",
                    maxWidth: "400px",
                  }}
                  fullWidth>
                  {slide === onBoardingConfig.length - 1 ? (
                    <Col type="bc" sx={{ gap: "10px" }} fullWidth>
                      <Box
                        sx={{
                          width: "100%",
                          maxWidth: "400px",
                          padding: "0 36px",
                        }}>
                        <BasicButton variant="white" sx={{ width: "100%" }} onClick={handleOnboard}>
                          <Typography variant="mobile-body-m-heavy">Start Now</Typography>
                        </BasicButton>
                      </Box>
                      <Box
                        sx={{
                          width: "100%",
                          maxWidth: "400px",
                          padding: "0 36px",
                          opacity: "0",
                          pointerEvents: "none",
                        }}>
                        <BasicButton
                          variant="black"
                          sx={{
                            width: "100%",
                            border: "none",
                            backgroundColor: "transparent",
                            "&:hover": {
                              backgroundColor: `${theme.palette.surface.black}33 !important`,
                            },
                          }}
                          onClick={handleOnboard}>
                          <Typography variant="mobile-body-m-heavy">Skip</Typography>
                        </BasicButton>
                      </Box>
                    </Col>
                  ) : (
                    <Col type="bc" sx={{ gap: "10px" }} fullWidth>
                      <Box
                        sx={{
                          width: "100%",
                          maxWidth: "400px",
                          padding: "0 36px",
                        }}>
                        <BasicButton
                          variant="white"
                          sx={{ width: "100%" }}
                          onClick={handleNextSlide}>
                          <Typography variant="mobile-body-m-heavy">Next</Typography>
                        </BasicButton>
                      </Box>
                      <Box
                        sx={{
                          width: "100%",
                          maxWidth: "400px",
                          padding: "0 36px",
                        }}>
                        <BasicButton
                          variant="black"
                          sx={{
                            width: "100%",
                            border: "none",
                            backgroundColor: "transparent",
                            "&:hover": {
                              backgroundColor: `${theme.palette.surface.black}33 !important`,
                            },
                          }}
                          onClick={handleOnboard}>
                          <Typography variant="mobile-body-m-heavy">Skip</Typography>
                        </BasicButton>
                      </Box>
                    </Col>
                  )}
                </Row>
              </Col>
            </Col>
          </Col>
        </OnboardingCardV2>
      </ViewPoint.Mobile>
      <ViewPoint.Desktop>
        <OnboardingCardV2
          sx={{
            display: "flex",
            position: "relative",
            backgroundImage: `
              linear-gradient(
                to left,
                ${theme.palette.surface.black}00 0%,
                ${theme.palette.surface.black}00 90%,
                ${theme.palette.surface.black}FF 95%,
                ${theme.palette.surface.black}FF 100%
              ),
              linear-gradient(
                to right,
                ${theme.palette.surface.black}00 0%,
                ${theme.palette.surface.black}00 90%,
                ${theme.palette.surface.black}FF 95%,
                ${theme.palette.surface.black}FF 100%
              ),
              linear-gradient(
                to bottom,
                ${theme.palette.surface.black}00 0%,
                ${theme.palette.surface.black}00 50%,
                ${theme.palette.surface.black}FF 90%,
                ${theme.palette.surface.black}FF 100%
              ),
              url("${onBoardingConfig[slide].image}")
            `,
            backgroundPosition: "0 70%",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            margin: "0 auto",
            width: "100%",
            // maxWidth: "1200px",
          }}>
          <Col fullHeight fullWidth>
            <Row
              type="se"
              sx={{
                gap: "16px",
                overflowX: "scroll",
                scrollSnapType: "x mandatory",
                msScrollSnapPointsX: "repeat(100vw)",
                textAlign: "start",
              }}
              fullWidth
              fullHeight>
              {children}
            </Row>
            <Row type="ss" sx={{ padding: "20px" }} fullWidth>
              <Col type="ss" fullWidth>
                <Row
                  type="bc"
                  sx={{
                    padding: "0",
                    gap: "10px",
                    maxWidth: "400px",
                  }}
                  fullWidth>
                  {slide === onBoardingConfig.length - 1 ? (
                    <Row type="bc" sx={{ gap: "10px" }} fullWidth>
                      <BasicButton
                        variant="white"
                        sx={{ flex: "1", width: "100%" }}
                        onClick={handleOnboard}>
                        <Typography variant="mobile-body-m-heavy">Start Now</Typography>
                      </BasicButton>
                      <BasicButton
                        variant="black"
                        sx={{
                          flex: "1",
                          width: "100%",
                          border: "none",
                          backgroundColor: "transparent",
                          "&:hover": {
                            backgroundColor: `${theme.palette.surface.black}33 !important`,
                          },
                        }}
                        onClick={handleOnboard}>
                        <Typography variant="mobile-body-m-heavy">Skip</Typography>
                      </BasicButton>
                    </Row>
                  ) : (
                    <Row type="bc" sx={{ gap: "10px" }} fullWidth>
                      <BasicButton variant="white" sx={{ width: "100%" }} onClick={handleNextSlide}>
                        <Typography variant="mobile-body-m-heavy">Next</Typography>
                      </BasicButton>
                      <BasicButton
                        variant="black"
                        sx={{
                          width: "100%",
                          border: "none",
                          backgroundColor: "transparent",
                          "&:hover": {
                            backgroundColor: `${theme.palette.surface.black}33 !important`,
                          },
                        }}
                        onClick={handleOnboard}>
                        <Typography variant="mobile-body-m-heavy">Skip</Typography>
                      </BasicButton>
                    </Row>
                  )}
                </Row>
                <Row sx={{ height: "40px" }} />
                <Stepper
                  sx={{
                    width: "100%",
                  }}
                  isHidePageNumber
                  slide={slide}
                  totalSlides={onBoardingConfig.length}
                  handleSlideChange={handleSlideChange}
                />
                <Typography variant="mobile-action-xs-heavy">
                  Step {slide + 1} of {onBoardingConfig.length}
                </Typography>
              </Col>
            </Row>
          </Col>
        </OnboardingCardV2>
      </ViewPoint.Desktop>
    </FullViewContainer>
  );
};

export default OnboardingWrapper;
